import React from "react";

const SiemensSummary = () => {
  return (
    <div className="about_area aws-challenge">
      <div className="container">
        <div className="row">
             <div className="section_main_title mb-3">
                <h3>In Summary</h3>
              
              </div>
         <div className="col-lg-12 col-md-6 col-sm-12 col-xs-6">
           
            <div className="singel_about_left text-left">
              
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                  
                </div>
                
              </div>
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                
                </div>
                <div className="singel-about-content">
                 <p>This wasn’t a story about “more data” or “better tools.” It was about getting three things right:
</p>
                  <p>
                  ● Knowing which region needs what
 <br/> ● Understanding how each vertical behaves
 <br/> ● Choosing the right campaign flow for both
                  </p>
                  <p>Scaling globally demands precision, not uniformity, and that’s exactly what this partnership achieved.
</p>
                </div>
              </div>
             
             
            </div>
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default SiemensSummary;
